/** Ported from the Angular HRM app's `Genders` constant; `labelKey` is the UILM key its template translates. */
export const GENDER_OPTIONS = [
  { value: 'MALE', labelKey: 'MALE' },
  { value: 'FEMALE', labelKey: 'FEMALE' },
  { value: 'OTHER', labelKey: 'OTHER' },
  { value: 'NA', labelKey: 'NA_GENDER' },
] as const;
